import React from 'react'
import {urlFor} from '../lib/client';
import { AiFillPlusCircle } from 'react-icons/ai';
import VisDiv from './frontend_components/VisDiv';

const TitleWithIcon = ({icon, title, style, fontSize, iconSize, vertical, additionalTitle, plus, isActive}) => {
  const flexDirection = vertical ? "column" : "row"
  const marginIconLeft = (iconSize * 6)/100
  const activeBorder = isActive && {border:"2px solid blue", borderRadius:"50%", paddingLeft: `${marginIconLeft}px`, paddingTop: `${marginIconLeft}px`}
  return (
    <div className='register-title-container' style={{fontSize:fontSize, flexDirection: flexDirection}}>
      <VisDiv rules={[plus]} style={{position:"absolute", marginLeft:`${iconSize - 20}px`}}><AiFillPlusCircle size={15} color='red'/></VisDiv>
        { icon && (<div style={{display:"flex", marginRight:"5px",...activeBorder}}><img src={urlFor(icon)} alt="register-icon" className="register-logo" style={{width: iconSize, height: iconSize }} /></div>)}
        { title && (<h1>{title}</h1> )} 
        { additionalTitle ? (<h1>{additionalTitle}</h1> ): vertical && (<h1 style={{color:"rgba(255, 0, 0, 0)", }}>_</h1> )} 
    </div>
  )
}

export default TitleWithIcon


/* 
         { icon && (<img src={icon} alt="register-icon" className="register-logo" />)}
        { title && (<h1>{title}</h1> )} 
*/


